import * as React from 'react';

import { observer } from 'mobx-react';

import { SocialBanner } from '~components/SocialBanner';
import { SignInTypeWithoutGuest } from '~constants/SignInTypeEnum';
import { SignUpType } from '~constants/SignUpTypeEnum';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';

import { SignUp } from '../signup/SignUp';
import { ConsentFormViewController } from './ConsentFormViewController';

const consentWrapperClasses = classes('iam-consent-form-wrapper');

export const ConsentForm = observer(() => {
    const viewController: ConsentFormViewController = diContainer.get(
        serviceNames.consentFormViewController
    );
    const { socialAccountRegistration } = useTranslation();
    const { providerName, submitButtonText } = viewController.data;

    React.useEffect(() => {
        viewController.loaded();
    }, []);

    return (
        <div className={consentWrapperClasses}>
            <SocialBanner
                providerName={providerName as SignInTypeWithoutGuest}
                bannerText={socialAccountRegistration}
            />
            {/* Registration status of account created with this form is always complete */}
            <SignUp
                hideSocialButtons
                submitButtonLabel={submitButtonText}
                signUpType={SignUpType.COMPLETE}
            />
        </div>
    );
});
